export const statuses = ['active', 'inactive', 'design'];
export const newUserStatuses = ['active', 'inactive'];
